// extracted by mini-css-extract-plugin
export default {"hidden":"ResetPassword__hidden--iDUU_","container":"ResetPassword__container--mbeUS","wrapper":"ResetPassword__wrapper--YsE_1","okButton":"ResetPassword__okButton--GStZS"};